import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { slide as Menu } from "react-burger-menu";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "./App.scss";
import "./assets/scss/main.scss";
import CloseIcon from "./components/closeIcon/CloseIcon";
import HamburgerIcon from "./components/hamburgerIcon/HamburgerIcon";
import Sidebar from "./components/sidebar/Sidebar";
import UserDetails from "./components/userDetails/UserDetails";
import ForgetPassword from "./pages/publicViews/forgetPassword/ForgetPassword";
import Login from "./pages/publicViews/login/Login";
import TermsAndConditions from "./pages/publicViews/termsAndConditions/TermsAndConditions";
import VerifyOTP from "./pages/publicViews/verifyOTP/VerifyOTP";
import PrivateLayout from "./routes/PrivateLayout";
import PublicRoute from "./routes/PublicRoute";
import { IRootState } from "./store/configureStore";
import GuestInquiry from "./pages/guestInquiry/GuestInquiry";
import "./assets/css/main.scss";

import BillQuickPay from "./pages/billing/billQuickPay/BillQuickPay";

const navStyles = {
  bmBurgerButton: {
    position: "fixed",
    width: "36px",
    height: "30px",
    left: "24px",
    top: "24px",
  },
  bmBurgerBars: {
    background: "#000",
  },
  bmMenuWrap: {
    background: "#ffffff",
  },
  bmCrossButton: {
    width: "25px",
    height: "25px",
    right: "-40px",
  },
};

function App() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAuthenticated } = useSelector(({ auth }: IRootState) => ({
    isAuthenticated: auth.loggedIn,
  }));

  return (
    <Row
      className="justify-content-center align-items-center vh-100"
      id="page-wrap"
    >
      {isAuthenticated && (
        <div className="d-block d-md-none">
          <Menu
            pageWrapId={"page-wrap"}
            outerContainerId={"outer-container"}
            customBurgerIcon={<HamburgerIcon />}
            customCrossIcon={<CloseIcon />}
            styles={navStyles}
            isOpen={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
          >
            <Row>
              <Col className="px-3">
                <UserDetails setIsOpen={setIsOpen} />
              </Col>
            </Row>
            <Sidebar setIsOpen={setIsOpen} />
          </Menu>
        </div>
      )}
      <Routes>
        <Route path="/" element={<PublicRoute />}>
          <Route index element={<Login />} />
          <Route path="" element={<Login />} />
          <Route path="forgetPassword" element={<ForgetPassword />} />
          <Route path="verifyOtp" element={<VerifyOTP />} />
          <Route path="termsAndConditions" element={<TermsAndConditions />} />
          <Route path="guestInquiry" element={<GuestInquiry />} />

          <Route path="billQuickPay" element={<BillQuickPay />} />
        </Route>

        <Route path="/*" element={<PrivateLayout />} />
      </Routes>
    </Row>
  );
}

export default App;
